import React, { useEffect, useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { sendBookingNotification } from '../../../services/requests/bookings/bookings-requests';

// The edit form publishes the mail view model here (after Save or Notify Agent); the page swaps views.
let listener: ((notification: any) => void) | null = null;
export const publishBookingNotification = (notification: any) => listener?.(notification);

export const useBookingNotification = () => {
  const [notification, setNotification] = useState<any>(null);
  useEffect(() => {
    listener = setNotification;
    return () => {
      listener = null;
    };
  }, []);
  return notification;
};

// Legacy Bookings_Edit "Mail" view (pnlMail).
export const BookingNotificationView = ({ notification }: { notification: any }) => {
  const navigate = useNavigate();
  const [to, setTo] = useState<string[]>(notification.selectedRecipients ?? []);
  const [cc, setCc] = useState('');
  const [body, setBody] = useState<string>(notification.body ?? '');
  const [sending, setSending] = useState(false);

  // btnSendMail_Click always ends with Response.Redirect("Bookings.aspx").
  const send = async () => {
    setSending(true);
    try {
      await sendBookingNotification(notification.bookingId, { to, cc, body });
    } catch {
      // the request helper already reported the error
    } finally {
      setSending(false);
    }
    navigate('/bookings');
  };

  return (
    <div className="p-3" style={{ maxWidth: 680 }}>
      <h5 className="mb-3">Logistics - Bookings - Edit</h5>
      <p>Following Email will be sent to the Booking Agent:</p>
      <Form.Group className="mb-2 d-flex">
        <Form.Label style={{ width: 90 }}>From:</Form.Label>
        <span>{notification.from}</span>
      </Form.Group>
      <Form.Group className="mb-2 d-flex">
        <Form.Label style={{ width: 90 }}>To:</Form.Label>
        <Form.Select
          multiple
          size="sm"
          style={{ height: 160 }}
          value={to}
          onChange={(e) => setTo(Array.from((e.target as HTMLSelectElement).selectedOptions).map((o) => o.value))}
        >
          {(notification.recipients ?? []).map((r: string, i: number) => (
            <option key={`${r}-${i}`} value={r}>{r}</option>
          ))}
        </Form.Select>
      </Form.Group>
      <Form.Group className="mb-2 d-flex">
        <Form.Label style={{ width: 90 }}>Copy To:</Form.Label>
        <Form.Control size="sm" value={cc} onChange={(e) => setCc(e.target.value)} />
      </Form.Group>
      <Form.Group className="mb-2 d-flex">
        <Form.Label style={{ width: 90 }}>Date:</Form.Label>
        <span>{notification.date}</span>
      </Form.Group>
      <Form.Group className="mb-3 d-flex">
        <Form.Label style={{ width: 90 }}>Subject:</Form.Label>
        <span>{notification.subject}</span>
      </Form.Group>
      <Form.Control as="textarea" rows={12} value={body} onChange={(e) => setBody(e.target.value)} />
      <div className="mt-3 d-flex gap-2">
        <Button size="sm" onClick={send} disabled={sending}>
          Send Email {sending && <Spinner animation="border" size="sm" />}
        </Button>
        <Button size="sm" variant="outline-secondary" onClick={() => navigate('/bookings')} disabled={sending}>
          Back
        </Button>
      </div>
    </div>
  );
};
